import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Row, Spinner,Form,Button } from 'react-bootstrap';
import { Line, Pie } from 'react-chartjs-2';
import { LanguageContext } from '../Language/LanguageContext';
import { countEntranceStat, countVisitorByMonth, countVisitorByType } from '../Network/Visitor';
import { Loading } from '../Library';
import "./Dashboard.css"
import axios from 'axios'
import { wtc5214, visitor8082 } from '../Network/Config'
import DatePicker from "react-datepicker";

function abbreviateNumber(value) {
    var newValue = value;
    if (value >= 1000) {
        var suffixes = ["", "k", "m", "b","t"];
        var suffixNum = Math.floor( (""+value).length/3 );
        var shortValue = '';
        for (var precision = 2; precision >= 1; precision--) {
            shortValue = parseFloat( (suffixNum !== 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
            var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
            if (dotLessShortValue.length <= 2) { break; }
        }
        if (shortValue % 1 !== 0)  shortValue = shortValue.toFixed(1);
        newValue = shortValue+suffixes[suffixNum];
    }
    return newValue;
}

function Dashboard(props) {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.visitor
    const [todate, setTodate] = useState(0)
    const [tomonth, setTomonth] = useState(0)
    const [toyear, setToyear] = useState(0)
    const [countFastRegister, setCountFastRegister] = useState(0)
    const [countRegister, setCountRegister] = useState(0)
    const [countContractor, setCountContractor] = useState(0)
    const [countEnterarea, setCountEnterarea] = useState(0)
    const [countEtc, setCountEtc] = useState(0)
    const [countSend, setCountSend] = useState(0)
    const [countChartData, setCountChartData] = useState([10,30])
    const [countChartLabels, setCountChartLabels] = useState([5,30])
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(()=>{
        const fetchData = async () => {
            try{
                setIsLoading(true)
                const formData = new FormData();
                formData.append('company_name', props.company);
                if(startDate == null || endDate == null){
                    formData.append('start_date', dayjs().format("YYYY-MM-DD"));
                    formData.append('end_date', dayjs().add(1,'day').format("YYYY-MM-DD"));
                }else{
                    formData.append('start_date', dayjs(startDate).format("YYYY-MM-DD"));
                    formData.append('end_date', dayjs(endDate).format("YYYY-MM-DD"));
                }
                
                await axios.post(visitor8082+'/visitor/api/v1/dashboard', formData).then(function (responseData) {
                    console.log('Res : ',responseData)
                    setCountContractor(responseData.data.count_contractor)
                    setCountEnterarea(responseData.data.count_enterarea)
                    setCountEtc(responseData.data.count_etc)
                    setCountSend(responseData.data.count_send)
                    setTodate(responseData.data.todate);
                    setTomonth(responseData.data.tomonth);
                    setToyear(responseData.data.toyear);
                    setCountFastRegister(responseData.data.countfastregister);
                    setCountRegister(responseData.data.countregister);
                    setCountChartData(responseData.data.chart.data);
                    setCountChartLabels(responseData.data.chart.labels);
                    console.log('False')
                    setIsLoading(false)
                }).catch(function (error) {
                    setIsLoading(false)
                    console.log(error);
                });
            }catch (e) {
                console.error(e);
                setIsLoading(false)
            }
        }
        fetchData(); 
    }, [5000, props.company, startDate,endDate]);

    const OverallStat = () => {
        const [isLoadingStat, setIsLoadingStat] = useState(false)
        const [hourCount, setHourCount] = useState(0)
        const [todayCount, setTodayCount] = useState(0)
        const [weekCount, setWeekCount] = useState(0)
        const [monthCount, setMonthCount] = useState(0)
        const [yearCount, setYearCount] = useState(0)

        /*useEffect( async ()=>{
            const fetchStat = () => {
                setIsLoadingStat(true)
                countEntranceStat(
                    (data)=>{
                        setHourCount(data.hour)
                        setTodayCount(data.day)
                        setWeekCount(data.week)
                        setMonthCount(data.month)
                        setYearCount(data.year)
                        setIsLoadingStat(false)
                    },
                    (error)=>{ 
                        setIsLoadingStat(false)
                    }
                )
            }
            fetchStat()
        },[])*/

        return(
            <div className='widget-item'>
                
                <div className='widget-head'>
                    <div className='widget-title'>{lang.entrance_stat}</div>
                    <div>
                        { isLoadingStat ?
                        <Spinner 
                        variant='primary'
                        size='sm'
                        animation='border'/>
                        : null
                        }
                    </div>
                </div>
                <div className='overall-stat' style={{ marginBottom: 13 }}>
                    {/*<div className='overall-item'>
                        <div className='value-main'>{abbreviateNumber(hourCount)}</div>
                        <div className='title'>{lang.hour_count}</div>
                    </div>*/}
                    <div className='overall-item'>
                        <div className='value-main'>{abbreviateNumber(todate)}</div>
                        <div className='title'>{lang.today_count}</div>
                    </div>
                   
                </div>
                <hr/>
                <div className='overall-stat'>
                    {/*<div className='overall-item'>
                        <div className='value'>{abbreviateNumber(weekCount)}</div>
                        <div className='title'>{lang.week_count}</div>
                    </div>*/}
                    <div className='overall-item'>
                        <div className='value'>{abbreviateNumber(tomonth)}</div>
                        <div className='title'>{`${lang.month_count} (${dayjs().format("MMM")})`}</div>
                    </div>
                    <div className='overall-item'>
                        <div className='value'>{abbreviateNumber(toyear)}</div>
                        <div className='title'>{`${lang.year_count} (${dayjs().format("YYYY")})`}</div>
                    </div>
                </div>
            </div>
        )
    }

    const CountEntranceChartStat = () => {
        const [isLoadingEntranceCount, setIsLoadingEntranceCount] = useState(false)
        const [labels, setLabels] = useState([])   
        const [countData, setCountData] = useState([])     

        /*useEffect(()=>{
            const fetchCountEntranceChartStat = () => {
                setIsLoadingEntranceCount(true)
                countVisitorByMonth(
                    (data) => {
                        data.forEach((item) => {
                            setLabels((prev) => [...prev, dayjs(item.registerMonth).format("MMMM")])
                            setCountData((prev) => [...prev, item.countRegister])
                            setIsLoadingEntranceCount(false)
                        })
                    },
                    (error) => { 
                        setIsLoadingEntranceCount(false)
                    }
                )
                
            }
            fetchCountEntranceChartStat()
        },[])*/

        return(
            <div className='widget-item'>
                <div className='widget-head'>
                    <div className='widget-title'>{lang.count_entrance_by_month}</div>
                    <div>
                        { isLoadingEntranceCount ?
                        <Spinner 
                            variant='primary'
                            size='sm'
                            animation='border'/>
                        : null
                        }
                    </div>
                </div>
                <div style={{ height: 300 }}>
                    <Line 
                    legend={{
                        display: true,
                        labels: ['จำนวนคน']
                    }}
                    data={{
                        labels: countChartLabels,
                        datasets: [
                            {
                                data: countChartData,
                                borderColor: '#00275e',
                                lineTension: 0.1,
                                pointBackgroundColor: '#00275e',
                                pointRadius: 6,
                                pointHoverRadius: 5,
                                pointHitRadius: 5,
                                fill: false
                            },
                        ]
                    }}
                    options={{
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [
                                {
                                    ticks:{
                                        beginAtZero: true,
                                        stepSize: 2
                                    }
                                }
                            ]
                        }
                    }}
                    />
                </div>
            </div>
        )
    }

    const TypeChart = () => {
        const [isLoadingType, setIsLoadingType] = useState(false)
        const [registeredCount, setRegisteredCount] = useState(0)
        const [fastCount, setFastCount] = useState(0)

        /*useEffect(()=>{
            const fetchCountType = () => {
                setIsLoadingType(true)
                countVisitorByType(
                    (data) => {
                        setRegisteredCount(data.registered)
                        setFastCount(data.fast_registered)
                        setIsLoadingType(false)
                    },
                    (error) => {
                        setIsLoadingType(false)
                    })
            }
            fetchCountType()
        },[])*/

        return(
            <div className='widget-item'>
                <div className='widget-head'>
                    <div className='widget-title'>{lang.type}</div>
                    <div>
                    { isLoadingType ?
                        <Spinner 
                            variant='primary'
                            size='sm'
                            animation='border'/>
                        : null
                    }
                    </div>
                </div>
                <div style={{ height: 200 }}>
                    <Pie
                    data={{
                        labels: [lang.count_contractor, lang.count_enterarea, lang.count_send, lang.count_etc],
                        datasets: [
                            {
                                data: [countContractor, countEnterarea, countSend, countEtc],
                                backgroundColor:  [
                                    'rgba(54, 162, 235, 0.5)',
                                    'rgba(255, 99, 132, 0.5)',
                                    'rgba(117, 255, 144, 0.5)',
                                    'rgba(255, 255, 118, 0.5)',
                                ]
                            }
                        ]
                    }}
                    options={{
                        maintainAspectRatio: false
                    }}
                    />
                </div>
            </div>

        )
    }

    const downloadDoc = async () => {
        try {
            setIsLoading(true)
            const formData = new FormData();
            formData.append('company_name', props.company);
                if(startDate == null || endDate == null){
                    formData.append('start_date', dayjs().format("YYYY-MM-DD"));
                    formData.append('end_date', dayjs().add(1,'day').format("YYYY-MM-DD"));
                }else{
                    formData.append('start_date', dayjs(startDate).format("YYYY-MM-DD"));
                    formData.append('end_date', dayjs(endDate).format("YYYY-MM-DD"));
                }
            const response = await axios.post(
                'https://visitor-api.lifelink.co.th:8082/visitor/api/v1/dashboard_report.xlsx', 
                formData,
                {
                    responseType: 'blob',
                }
            );

            console.log(response.data)
    
            // 4. จัดการการสร้างลิงก์ดาวน์โหลด
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            
            // กำหนดชื่อไฟล์สำหรับดาวน์โหลด
            // คุณอาจจะต้องดึงชื่อไฟล์จริงจาก Header 'Content-Disposition' ของ Response
            // แต่ถ้าไม่มี ให้ตั้งชื่อเองตามวันที่
            const fileName = `dashboard_report_${new Date().toLocaleDateString('en-CA')}.xlsx`;
            
            link.href = url;
            link.setAttribute('download', fileName); // กำหนดชื่อไฟล์
            document.body.appendChild(link);
            link.click(); // คลิกลิงก์เพื่อเริ่มดาวน์โหลด
            link.remove(); // ลบลิงก์หลังจากดาวน์โหลดเสร็จ
    
            window.URL.revokeObjectURL(url); // ปล่อยทรัพยากร
        } catch (error) {
            console.error("Download Error:", error.response ? error.response.data : error.message);
            // เพิ่มการจัดการ Error 401, 403, หรืออื่น ๆ
        } finally {
            setIsLoading(false);
        }

    }

    return(
        <div id="visitor-dashboard">
            { isLoading ? <Loading/> : null }
            <div style={{paddingTop:10}}>
            <Row>
                <Col xs={12} md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่เริ่มต้น'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่เริ่มต้น'}
                                maxDate={new Date()}
                                />
                                </div>
                            </Form.Group>
                </Col>
                <Col xs={12} md={5} lg={5}>
                            <Form.Group>
                                <Form.Label>{'วันที่สิ้นสุด'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>{
                                    setEndDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่สิ้นสุด'}
                                maxDate={new Date()}
                                minDate={startDate}
                                />
                                </div>
                            </Form.Group>
                </Col>
                <Col xs={12} md={1} lg={1} className="mb-3" style={{alignSelf: 'end',justifyContent:'end'}}>
                <Button 
                    onClick={downloadDoc} 
                    style={{ height: '38px', width: '100%', fontSize:'13px' }} // กำหนดความสูงให้ตรงกับ input field มาตรฐาน
                >
                    ดาวน์โหลด
                </Button>
            </Col>
            </Row>
            </div>
            <Row>
                <Col md={6}>
                    <OverallStat/>
                </Col>
                <Col md={6}>
                    <TypeChart/>
                </Col>
                <Col xs={12}>
                    <CountEntranceChartStat/>
                </Col>
            </Row>
        </div>
    )
}

export default Dashboard;
